export function checkObjectValues(object) {
    // Iterate through each attribute of the object
    for (const key in object) {
        // Check if the current attribute value is a string or an array
        if (typeof object[key] === "string" || Array.isArray(object[key])) {
            // If the value is not an empty string, empty array, or null, return true
            if (object[key].length > 0) {
                return true;
            }
        }
        // If the current attribute value is an object, recursively check its values
        else if (typeof object[key] === "object" && object[key] !== null) {
            if (checkObjectValues(object[key])) {
                return true;
            }
        }
    }

    // Return false if no non-empty values were found
    return false;
}

export const checkIsObjectEmpty = (obj) => Object.keys(obj).length === 0;
